import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue";

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "年卡会员", -1);

const _hoisted_2 = {
  key: 0,
  class: "base_screen_header"
};
const _hoisted_3 = {
  class: "dialog-footer"
};
const _hoisted_4 = {
  class: "dialog-footer"
};
const _hoisted_5 = {
  style: {
    "width": "100%",
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_6 = {
  class: "dialog-footer"
};
import { ref, reactive } from "vue";
import api from "@api/memberGrade";
import equityApi from "@api/equity";
import $ from "@util/base";
import useRoute from "@util/router";
import DataCollectTable from "@/components/table/DataCollectTable.vue";
import { COLUMN_TYPE, OP_KEY, OPERATIONS, operationsHander } from "@/components/table/tableOperations";
import { $box, $msg } from "@/common/ui/msg";
export default {
  __name: 'MemberGradePlusManager',

  setup(__props) {
    const data = ref([]);
    const plusData = ref([]);
    const route = useRoute();
    const config = {
      showIndex: true,
      operations: {
        label: "操作",
        width: 120,
        operations: getOperations
      },
      column: [{
        label: "会员名称",
        prop: "name"
      }, {
        label: "人数",
        prop: "num"
      }, {
        label: "权益",
        prop: "mrpInstall"
      }]
    };
    const plusConfig = {
      showIndex: true,
      operations: {
        label: "操作",
        width: 120,
        operations: plusGetOperations
      },
      column: [{
        label: "上架状态",
        prop: "status",
        type: COLUMN_TYPE.switch,
        operationsKey: OPERATIONS.switch,
        activeText: "已上架",
        inactiveText: "未上架",
        activeValue: "已上架",
        inactiveValue: "未上架",
        switchWidth: 65
      }, {
        label: "人数",
        prop: "num"
      }, {
        label: "价格",
        prop: "price",
        type: COLUMN_TYPE.input,
        operationsKey: OPERATIONS.input
      }]
    };
    const dialogVisible = ref(false);
    const dialogVisibleTitle = ref("新增会员等级");
    const baseFormRef = ref(null);
    const baseForm = ref({
      name: "",
      type: null
    });
    const baseFormRules = {
      name: [{
        required: true,
        message: "请输入会员名称",
        trigger: "blur"
      }]
    };
    const isAdd = ref(true);
    const bindDialogVisible = ref(false);
    const bindBaseFormRef = ref(null);
    const bindBaseForm = ref({
      code: null,
      name: null,
      equityCode: null
    });
    const bindBaseFormRules = {
      code: [{
        required: true,
        message: "请选择会员等级",
        trigger: "blur"
      }],
      equityCode: [{
        required: true,
        message: "请选择权益",
        trigger: "blur"
      }]
    };
    const equityList = ref([]);
    const qrCodedialogVisible = ref(false);

    function getOperations(data) {
      let op = [OPERATIONS.modify, OPERATIONS.qrCodeRegister];

      if (data.num <= 0) {
        op.push(OPERATIONS.del);
      }

      if (data.mrpInstall == '暂时未选择') {
        op.push(OPERATIONS.bind);
      }

      op.push(OPERATIONS.lockMember);
      return op;
    }

    function plusGetOperations(data) {
      let op = [OPERATIONS.lockMember, OPERATIONS.setUp];
      return op;
    }

    const opHander = operationsHander();
    opHander.install(OP_KEY.lockMember, data => {
      route.push({
        name: 'memberList',
        query: {
          tags: data.code,
          name: data.name
        }
      });
    });
    opHander.install(OP_KEY.input, data => {
      let status = data.data.status == "已上架" ? 1 : 0;
      data.status = status;
      data.price = data.value;
      data.code = data.data.code;
      api.plusUpdate(data, () => {
        $msg.succ("修改价格成功");
        getData();
      });
    });
    opHander.install(OP_KEY.switch, data => {
      let status = data.data.status == "已上架" ? 0 : 1;
      data.status = status;
      data.code = data.data.code;
      data.price = data.data.price;
      api.plusUpdate(data, () => {
        data.resolve(true);

        if (status == '1') {
          $msg.succ("上架成功");
        } else {
          $msg.succ("下架成功");
        }

        getData();
      }, () => {
        data.reject();
      });
    });
    opHander.install(OP_KEY.setUp, item => {
      if (item.equityCode == null) {
        route.push({
          name: 'memberGradePowerPlusDetails',
          query: {
            type: 'add',
            code: item.code
          }
        });
      } else {
        route.push({
          name: "memberGradePowerPlusDetails",
          query: {
            type: "modify",
            code: item.code,
            equityCode: item.equityCode
          }
        });
      }
    });
    const qrCode = ref('');
    opHander.install(OP_KEY.qrCodeRegister, item => {
      api.qrCodeRegister({
        code: item.code
      }, res => {
        qrCodedialogVisible.value = true;
        qrCode.value = res.filePath;
      });
    });
    getData();

    function getData() {
      api.list({}, res => {
        data.value = res.itemList.map(item => {
          item.type = 1039;
          return item;
        });
        plusData.value = res.plusItemList.map(item => {
          item.type = 1065;
          isAdd.value = false;
          return item;
        });
      });
    }

    function add(addType) {
      dialogVisibleTitle.value = "新增会员等级";
      baseForm.value = {
        name: "",
        type: addType
      };
      dialogVisible.value = true;
    }

    function submitForm() {
      baseFormRef.value.validate(valid => {
        if (valid) {
          if (baseForm.value.code) {
            api.update(baseForm.value, res => {
              $msg.succ("修改成功");
              dialogVisible.value = false;
              getData();
            });
          } else {
            api.add(baseForm.value, res => {
              $msg.succ("新增成功");
              dialogVisible.value = false;
              getData();
            });
          }
        } else {
          return false;
        }
      });
    }

    function submitBindForm() {
      bindBaseFormRef.value.validate(valid => {
        if (valid) {
          api.bind(bindBaseForm.value, res => {
            $msg.succ("绑定成功");
            bindDialogVisible.value = false;
            getData();
          });
        } else {
          return false;
        }
      });
    }

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_image = _resolveComponent("el-image");

      const _directive_auth = _resolveDirective("auth");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_main, {
        class: "base_main_content"
      }, {
        default: _withCtx(() => [_hoisted_1, isAdd.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = $event => add(2))
        }, {
          default: _withCtx(() => [_createTextVNode("新增")]),
          _: 1
        })), [[_directive_auth, _ctx.getCurCode('ADD')]])])) : _createCommentVNode("", true), _createVNode(DataCollectTable, {
          data: plusData.value,
          config: plusConfig,
          onOperationsHander: _unref(opHander).receive,
          "is-page": false
        }, null, 8, ["data", "onOperationsHander"])]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => dialogVisible.value = $event),
        title: dialogVisibleTitle.value,
        width: "35%",
        top: "35vh",
        class: "base_dialog"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitForm
        }, {
          default: _withCtx(() => [_createTextVNode("保存")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "baseFormRef",
          ref: baseFormRef,
          model: baseForm.value,
          rules: baseFormRules,
          "label-width": "100px",
          class: "base_details_form"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "等级名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: baseForm.value.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => baseForm.value.name = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_el_dialog, {
        modelValue: bindDialogVisible.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => bindDialogVisible.value = $event),
        title: "绑定权益",
        width: "50%",
        top: "35vh",
        class: "base_dialog"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_4, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitBindForm
        }, {
          default: _withCtx(() => [_createTextVNode("保存")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = $event => bindDialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "bindBaseFormRef",
          ref: bindBaseFormRef,
          model: bindBaseForm.value,
          rules: bindBaseFormRules,
          "label-width": "100px",
          class: "base_details_form"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "等级名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: bindBaseForm.value.name,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => bindBaseForm.value.name = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "权益",
            prop: "equityCode"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: bindBaseForm.value.equityCode,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => bindBaseForm.value.equityCode = $event),
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(equityList.value, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.name,
                  value: item.equityCode
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: qrCodedialogVisible.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => qrCodedialogVisible.value = $event),
        title: "扫码注册",
        width: "400px",
        top: "35vh",
        class: "base_dialog",
        center: "true"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_6, [_createVNode(_component_el_button, {
          onClick: _cache[8] || (_cache[8] = $event => qrCodedialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("关闭")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [qrCode.value != '' ? (_openBlock(), _createBlock(_component_el_image, {
          key: 0,
          src: 'data:image/png;base64,' + qrCode.value,
          style: {
            "width": "200px"
          }
        }, null, 8, ["src"])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};